// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NVYq","label":"styles_label__3GIuq"};